import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasic18({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M6.51 11.12V4.96H5.03v6.16h1.48zm3.16 0c.5 0 .9-.06 1.22-.19.32-.13.56-.28.73-.47a1.62 1.62 0 00.43-1.05 1.75 1.75 0 00-.98-1.5c.25-.17.45-.35.58-.54.13-.2.2-.45.2-.77a1.58 1.58 0 00-.46-1.13c-.17-.18-.4-.33-.68-.44a2.85 2.85 0 00-1.04-.16c-.4 0-.74.05-1.02.16a1.8 1.8 0 00-1.03 1c-.08.2-.12.4-.12.57 0 .31.07.57.2.77.14.2.33.38.58.53-.3.15-.54.36-.72.64a1.58 1.58 0 00-.18 1.36c.05.18.16.37.33.56.17.19.42.35.73.47.32.13.73.2 1.23.2zM8 .75c.28 0 .56.02.83.05a.75.75 0 01-.17 1.49 5.75 5.75 0 105.03 4.87.75.75 0 111.48-.22A7.25 7.25 0 118 .74zm1.68 7.62a.9.9 0 110 1.8.9.9 0 010-1.8zm-.01-2.5a.85.85 0 110 1.7.85.85 0 010-1.7zm-4.64-.89v1.5l-1.07.53V5.64l1.07-.66zM13 .25c.38 0 .7.28.74.65l.01.1v1h1a.75.75 0 01.1 1.5h-1.1v1a.75.75 0 01-1.5.1V3.5h-1a.75.75 0 01-.1-1.5h1.1V1c0-.41.34-.75.75-.75z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasic18.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasic18.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasic18 svgRef={ref} {...props} />);
export default ForwardRef;
